/**
 * 7-letter words for RSTLNE game
 * Exact words from original project
 */

const words7: string[] = [
  "ADMIRAL", "BALANCE", "CAPTURE", "DOLPHIN", "ECLIPSE", "FORTUNE", "GALLERY", "HARVEST", "IMAGINE", "JOURNEY",
  "KINGDOM", "LANTERN", "MYSTERY", "NETWORK", "ORCHARD", "PIONEER", "QUALITY", "REBUILD", "SHELTER", "TENSION",
  "UNICORN", "VILLAGE", "WARRIOR", "YAWNING", "ZEALOUS", "AMAZING", "BARGAIN", "CABINET", "DIAMOND", "ELEGANT",
  "FREEDOM", "GENUINE", "HARMONY", "INSIGHT", "JUSTICE", "KITCHEN", "LIBRARY", "MONSTER", "NATURAL", "OUTCOME",
  "PICTURE", "QUICKER", "RESPECT", "SINCERE", "TEACHER", "UMBRELLA", "VICTORY", "WHISPER", "ZEPHYR", "GLIMMER",
  "STATURE", "VENTURE", "CLARITY", "RESOLVE", "PASSION", "HORIZON", "TRIBUTE", "COURAGE", "SUNRISE", "BLOSSOM",
  "CAMPING", "FANTASY", "GRAVITY", "LEATHER", "OCTOBER", "PERFECT", "RAILWAY", "SILENCE", "THUNDER", "UNKNOWN",
  "WEATHER", "ZOMBIE", "AUCTION", "BICYCLE", "CHASSIS", "EMERALD", "GLOWING", "HOLIDAY", "INITIAL", "JEWELRY",
  "KINETIC", "MINERAL", "DECORUM", "ECOLOGY", "FICTION", "GARMENT", "IMPROVE", "JUKEBOX", "LOTTERY",
  "MACHINE", "ORIGAMI", "PHOENIX", "QUANTUM", "RECRUIT", "TEXTILE", "VALIANT", "AMNESIA", "DELIGHT",
  "EPISODE", "FRANTIC", "JOCULAR", "GESTURE", "HABITAT", "IMPULSE", "JAVELIN", "MANDATE", "NEUTRON", "OBELISK", "PHANTOM",
  "RACCOON", "THEOREM", "VOLCANO", "ADAPTER", "BOURBON", "CRUSADE", "DRYWALL", "EARRING", "FIREFLY", "GONDOLA",
  "HAMMOCK", "JACKPOT", "KETCHUP", "MAMMOTH", "NOMINAL", "OAKWOOD", "PYRAMID", "QUICKEN", "RAMPART", "SCALLOP",
  "VINTAGE", "YARDAGE", "PEACOCK", "ABANDON", "BALCONY", "DECLARE", "ELEMENT", "FACTORY", "INQUIRY", "JOURNAL",
  "LOYALTY", "PACKAGE", "QUARTER", "REALITY", "SCIENCE", "THEATER", "UNIFORM", "YOUNGER", "ABILITY", "BEDROOM",
  "CONCERN", "DEFENSE", "EVENING", "FOOLISH", "GARBAGE", "HUSBAND", "LIBERAL", "MORNING", "NEUTRAL", "OPINION",
  "PARKING", "SECTION", "TONIGHT", "UNUSUAL", "VEHICLE", "WESTERN", "ARCHIVE", "BENEFIT", "COTTAGE", "DESKTOP",
  "HANDLER", "OUTLINE", "QUICKLY", "REVENUE", "SUPPORT", "UPGRADE", "VERDICT", "WEDDING", "ANEMONE", "PELOTON",
  // New additions - September 19, 2025
  "AIRPORT", "AWESOME", "BLANKET", "COATING", "COMPLEX", "DISPLAY", "EMOTION", "FIFTEEN", "GATEWAY", "HIGHWAY",
  "ILLEGAL", "JASMINE", "KINSHIP", "LAWSUIT", "MIXTURE", "NEGLECT", "OPERATE", "PATIENT", "QUARREL", "REPTILE",
  "SATISFY", "TORRENT", "UNAWARE", "VIOLATE", "WELCOME", "EXPRESS", "YELLING", "ADVISER", "BROWSER", "CROWDED",
  "DENSITY", "ENDLESS", "FASHION", "GENERAL", "HEADING", "IMAGERY", "JUPITER", "KEYCARD", "MAILBOX", "NOTHING"
];

export default words7;
